import { render } from "./articleCategories.vue?vue&type=template&id=77e173cf"
import script from "./articleCategories.vue?vue&type=script&lang=js"
export * from "./articleCategories.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__